import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PLAN_CONFIG, type PlanKey } from "@/lib/plans";
import { EmbeddedCheckoutDialog } from "@/components/EmbeddedCheckoutDialog";

interface UpgradeHintProps {
  title: string;
  description: string;
  targetPlan?: "plus" | "together";
  ctaLabel?: string;
  /** If true, CTA triggers embedded Stripe checkout */
  useCheckout?: boolean;
  /** For Flyt Sammen plan: which family to activate for */
  familyId?: string;
  className?: string;
}

const defaultCta: Record<string, string> = {
  plus: "Prøv 14 dager gratis",
  together: "Oppgrader til Flyt Sammen",
};

const planLabels: Record<string, string> = {
  plus: "Flyt Pluss",
  together: "Flyt Sammen",
};

export function UpgradeHint({
  title,
  description,
  targetPlan = "plus",
  ctaLabel,
  useCheckout = false,
  familyId,
  className = "",
}: UpgradeHintProps) {
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const label = ctaLabel ?? defaultCta[targetPlan] ?? "Se mer";
  const planConfig = PLAN_CONFIG[targetPlan as PlanKey];

  return (
    <div className={`rounded-xl border border-border bg-muted/30 p-4 space-y-2 ${className}`}>
      <p className="font-display font-semibold text-sm">{title}</p>
      <p className="text-sm text-muted-foreground">{description}</p>
      {useCheckout ? (
        <>
          <Button variant="outline" size="sm" onClick={() => setCheckoutOpen(true)}>
            {label}
          </Button>
          {planConfig && (
            <EmbeddedCheckoutDialog
              open={checkoutOpen}
              onOpenChange={setCheckoutOpen}
              priceId={planConfig.price_id}
              familyId={familyId}
              planLabel={planLabels[targetPlan] ?? targetPlan}
            />
          )}
        </>
      ) : (
        <Button variant="outline" size="sm" asChild>
          <Link to={`/register?plan=${targetPlan}`}>{label}</Link>
        </Button>
      )}
    </div>
  );
}
